import axios from "axios"
import { useQuery } from "react-query"
import { memo } from "react"

const fetchDetails =
  (endpoint: string, valid: boolean) => async (props: any) => {
    if (!valid) return {}
    const { data } = await axios.get(endpoint)
    return data.results ?? data
  }

const ProductDisplay = (props: {
  id?: number
  className: any
  prefix?: string
}) => {
  const { data: product } = useQuery(
    ["product", props.id],
    fetchDetails(`/products/${props.id}`, !!props.id)
  )
  return (
    <div className={props.className}>
      <span>
        {props.prefix} {product?.title ?? ""}
      </span>
    </div>
  )
}

export default memo(ProductDisplay)
